import React from 'react'
import AccountsTab from './AccountsTab'
import { Box, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom'

const Accountpage = () => {
    const location = useLocation()
    const currentBooking = location.state?.bookingsData[0]

    return (
        <Box sx={{ p: 3, pt: 1 }}>

            {currentBooking ? (
                <Typography
                    variant="body1"
                    color="success.main"
                    sx={{ mb: 0, textAlign: 'center' }}
                >
                    
                </Typography>
            ) : (
                <Typography
                    variant="body1"
                    color="warning.main"
                    sx={{ mb: 2, textAlign: 'center' }}
                >
                    ⚠️ No active booking found
                </Typography>
            )}
            <AccountsTab bookingData={currentBooking} />
            <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 4, textAlign: 'center' }}
            >
                For any account-related issues, please contact our support team
            </Typography>
        </Box>
    )
}

export default Accountpage